import React, { Fragment, useMemo } from 'react';
import ReactTable from "react-table";
import {
    Card,
    CardBody,
    Button,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import DataTablePagination from '../../../../../../components/DatatablePagination';
const Stats = ({ data = [],}) => {
    const columns = useMemo(() => [

        {
            Header: "Date",
            accessor: "date",
            Cell: (props) => <p className="mb-0">{props.value}</p>,
            style: { whiteSpace: 'unset' },
        },
        {
            Header: "Messages sent by outbound trigger names",
            accessor: "triggername",
            Cell: (props) => <p className="mb-0">{props.value}</p>,
            style: { whiteSpace: 'unset' },
            minWidth: 200
        },
        {
            Header: "Channel with Message-Count",
            accessor: "messagedelivered",
            minWidth: 220,
            style: { whiteSpace: 'unset' },
            Cell: ({ value }) => {
                if (!Array.isArray(value) || value.length === 0) {
                    return <p className="mb-0">-</p>;
                }

                const text = value
                    .map(v => `${v.channel}: ${v.count}`)
                    .join(",  ");

                return <p className="mb-0">{text}</p>;
            }
        },
        {
            Header: "Messages received",
            accessor: "messagesreceived",
            minWidth: 200,
            style: { whiteSpace: 'unset' },
            Cell: ({ value }) => {
                if (!Array.isArray(value) || value.length === 0) {
                    return <p className="mb-0">0</p>;
                }

                const text = value
                    .map(v => `${v.channel}: ${v.count}`)
                    .join(",  ");

                return <p className="mb-0">{text}</p>;
            }
        }


    ], []);


    return (

        <Fragment>
            <Colxx xxs="12" className="mb-2">
                <Card className="mb-2">
                    <CardBody>
                        <Fragment>
                            <ReactTable
                                data={data}
                                columns={columns}
                                defaultPageSize={10}
                                className="-striped -highlight -bordered"
                                filterable={false}
                                //  showPageJump={true}
                                PaginationComponent={DataTablePagination}
                                showPageSizeOptions={true}

                            />
                        </Fragment>

                    </CardBody>
                </Card>
            </Colxx>
        </Fragment>

    );
};

export default Stats;
